import { z } from '../utils/zod-extend'

export const actionTypes = ['page_view'] as const
// export type ActionType = typeof actionTypes[number]

/**
 * 含む・除く
 */
const actionConfigConditionVarIncludeType = ['include', 'exclude'] as const
export type ActionConfigConditionVarIncludeType = typeof actionConfigConditionVarIncludeType[number]

// 以下、page conditions ============================

const actionConfigPageConditionVarTypes = ['path'] as const // 今後queryとか
// export type ActionConfigPageConditionVarType = typeof actionConfigPageConditionVarTypes[number]

export const actionConfigPageConditionVarValueOperators = ['equal', 'starts_with'] as const // 今後 'starts_with', 'ends_with', 'contains', 'regexp_match'とか
export type ActionConfigUserConditionVarValueOperator = typeof actionConfigPageConditionVarValueOperators[number]

export const actionConfigPageConditionSchema = z.object({
  vars: z.array(
    z.object({
      type: z.enum(actionConfigPageConditionVarTypes, { message: '不正な値です' }),
      includeType: z.enum(actionConfigConditionVarIncludeType, { message: '不正な値です' }),
      valueOp: z.enum(actionConfigPageConditionVarValueOperators, { message: '不正な値です' }),
      value: z.string()
        .min(1, { message: '必須です' })
      // remove last slash
        .transform(value => value.replace(/\/$/, ''))
        .refine((value) => {
          // スペースが含まれていないことを確認
          if (value.includes(' ')) {
            return false
          }

          try {
            // URLとして有効かチェック
            new URL(value, 'https://example.com')
            return value.startsWith('/')
          } catch {
            return false
          }
        }, {
          message: '/で始まるパスを入力してください',
        }),
    }),
  ).min(1, { message: '1つ以上の条件が必要です' }),
})
export type ActionConfigPageCondition = z.infer<typeof actionConfigPageConditionSchema>

export const actionConfigPageSchema = z.object({
  conditions: z.array(actionConfigPageConditionSchema),
})
export type ActionConfigPage = z.infer<typeof actionConfigPageSchema>

// 以下、user conditions ============================

const actionConfigUserConditionVarTypes = ['segment'] as const
// export type ActionConfigUserConditionVarType = typeof actionConfigUserConditionVarTypes[number]

export const actionConfigUserSchema = z.object({
  conditions: z.array(z.object({
    vars: z.array(z.object({
      type: z.enum(actionConfigUserConditionVarTypes),
      includeType: z.enum(actionConfigConditionVarIncludeType),
      value: z.string(),
    })),
  })),
})

/**
 * base
 * https://www.notion.so/asobica/research-action-config-json-schema-13dd4f867d21801dad88e2c3f130e003
 *
 * {
 *   // 条件s : 閲覧ページのパス、対象ユーザー
 *   // 今後、追加とかの可能性を考えて、funnelというobjectでラップ
 *   "funnel": {
 *     // 閲覧ページのパス
 *     "page": {
 *       // or条件 - 複数がorで動作する
 *       "conditions": [
 *         {
 *           // and条件 - 複数がandで動作する
 *           "vars": [
 *             {
 *               "type": "path",
 *               // include, exclude
 *               "includeType": "include",
 *               // equal, starts_with, ends_with, contains, regexp_match
 *               "valueOp": "equal",
 *               "value": "{uri.path}"
 *             }
 *             // {
 *             //   "type": "query",
 *             //   "valueOp": "equal",
 *             //   "value": "{uri.query}"
 *             // }
 *           ]
 *         }
 *       ]
 *     },
 *     // 対象ユーザー
 *     "user": {
 *       // or条件 - 複数がorで動作する
 *       "conditions": [
 *         {
 *           // and条件 - 複数がandで動作する
 *           "vars": [
 *             {
 *               // include, exclude
 *               "type": "segment",
 *               // include, exclude
 *               "includeType": "include",
 *               "value": "{segment.id}"
 *             },
 *             {
 *               // include, exclude
 *               "type": "segment",
 *               "valueOp": "exclude",
 *               "value": "{segment.id}"
 *             }
 *           ]
 *         }
 *       ]
 *     }
 *   }
 * }
 */
export const actionConfigSchema = z.object({
  funnel: z.object({
    page: actionConfigPageSchema.optional(),
    user: actionConfigUserSchema.optional(),
  }),
})
export type ActionConfig = z.infer<typeof actionConfigSchema>
